import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Redirects to /offline when the browser reports offline; restores to
 * the prior route (or /) when back online. Mounted once inside the router.
 */
export function useOnlineGuard() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let priorPath: string | null = location.pathname === '/offline' ? null : location.pathname + location.search;

    const onOffline = () => {
      if (location.pathname !== '/offline') {
        priorPath = location.pathname + location.search;
        navigate('/offline', { replace: true });
      }
    };
    const onOnline = () => {
      if (location.pathname === '/offline') {
        navigate(priorPath ?? '/', { replace: true });
      }
    };

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, [navigate, location]);
}
